import Cookies from 'js-cookie';

export function getAgeCookie() {
	return parseInt(Cookies.get('adventure-age'), 10) || false;
}

export function getAgeKeyFromCookie() {
	const ageCookie = getAgeCookie();

	if (ageCookie === false) {
		return 'default';
	}

	if (ageCookie <= 14) {
		return '14_under';
	}

	if (ageCookie >= 17) {
		return '17_over';
	}

	return 'default';
}
